import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationTouchID = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationTouchID',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70082)",
    fillRule: "evenodd",
    d: "M62.19 11.76a53.523 53.523 0 0 1 26.3 14.34 2.986 2.986 0 0 0 4.12.11l1.15-1.04a3.004 3.004 0 0 0 .11-4.36A61.744 61.744 0 0 0 63.81 4.32a62.79 62.79 0 0 0-27.62 0A61.82 61.82 0 0 0 6.12 20.81a3.004 3.004 0 0 0 .11 4.36l1.15 1.04a2.986 2.986 0 0 0 4.12-.11 53.523 53.523 0 0 1 26.3-14.34 54.863 54.863 0 0 1 24.39 0Zm-55 33.11 1.35.75c1.38.77 3.11.33 3.98-1a44.79 44.79 0 0 1 37.17-20.28c15.05-.1 29.07 7.35 37.42 19.72a3.01 3.01 0 0 0 4.04.92l1.33-.8c1.46-.88 1.92-2.81.97-4.22a52.329 52.329 0 0 0-87.32.69c-.95 1.43-.44 3.38 1.06 4.22ZM57.58 94.2c-.93-1.19-.84-2.89.23-3.96 3.43-3.42 10.1-11.38 10.1-21.69-.05-2.56-.6-5.09-1.62-7.44a17.917 17.917 0 0 0-20.1-10.06 17.929 17.929 0 0 0-13.92 14.93 2.985 2.985 0 0 1-2.96 2.57h-1.55c-1.81 0-3.23-1.6-2.98-3.39 1.46-10.43 9.28-19.04 19.8-21.33 11.64-2.54 23.48 3.34 28.51 14.15 1.53 3.32 2.34 6.92 2.37 10.57 0 13.19-8.17 22.93-12.46 27.16a2.994 2.994 0 0 1-4.47-.29c-.31-.41-.64-.83-.95-1.22Zm-20.53-1.11.21.58a2.99 2.99 0 0 0 4.11 1.68c6.4-3.05 20.6-11.56 20.6-26.76-.03-1.71-.39-3.4-1.08-4.96a12.075 12.075 0 0 0-10.9-7.01c-4.78 0-9.11 2.84-11 7.23-.65 1.5-.98 3.11-.97 4.75 0 4.53-3.67 8.2-8.2 8.2h-2.91c-4.53 0-8.2-3.67-8.2-8.2-.02-4.27.86-8.5 2.59-12.41a31.288 31.288 0 0 1 28.38-18.91 31.288 31.288 0 0 1 28.8 18.26c3.47 7.73 3.71 16.49.75 24.35-.55 1.45.06 3.08 1.45 3.77l1.37.68c1.59.79 3.5.04 4.15-1.61a37.73 37.73 0 0 0 2.65-14.14c0-5.58-1.17-11.09-3.45-16.18a38.938 38.938 0 0 0-35.8-22.66 38.945 38.945 0 0 0-35.31 23.42 39.515 39.515 0 0 0-3.13 15.43c0 8.7 7.05 15.75 15.75 15.75h2.91c8.7 0 15.75-7.05 15.75-15.75-.01-.59.1-1.18.32-1.73a4.648 4.648 0 0 1 4.1-2.7c1.71.04 3.26 1.04 3.99 2.59.3.57.45 1.2.43 1.83 0 10.78-11.13 17.42-16.2 19.86a3 3 0 0 0-1.5 3.72l.34.92Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70082",
    x1: 50,
    x2: 50,
    y1: 2.782,
    y2: 96.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#5DE6FE"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4961FF"
  }))));
};
ColoredIllustrationTouchID.displayName = 'ColoredIllustrationTouchID';
export default withProvisionalOverrideFromContext(ColoredIllustrationTouchID);
//# sourceMappingURL=index.js.map